import { render, staticRenderFns } from "./orderSku.vue?vue&type=template&id=133b3087"
import script from "./orderSku.vue?vue&type=script&lang=js"
export * from "./orderSku.vue?vue&type=script&lang=js"
import style0 from "./orderSku.vue?vue&type=style&index=0&id=133b3087&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports